import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { UserAvatar } from '@/components/ui/user-avatar';
import type { User } from '@/types/user';

interface UserResultItemProps {
  user: User;
  onPress: (identifier: string) => void;
}

export function UserResultItem({ user, onPress }: UserResultItemProps) {
  const username = user.username || user.displayUsername || '';
  const normalizedUsername = username.replace(/^@+/, '');
  const displayUsername = normalizedUsername ? `@${normalizedUsername}` : '';

  return (
    <Pressable
      onPress={() => onPress(normalizedUsername || user.id)}
      className="mb-4 p-4 rounded-lg flex-row items-center bg-surface border border-border"
      style={{ borderCurve: 'continuous' }}
    >
      <UserAvatar
        uri={user.image || user.avatar}
        name={user.name}
        size={64}
        accessibilityLabel={`${user.name || 'Unknown User'}'s profile photo`}
        style={{ marginRight: 12 }}
      />

      <View className="flex-1">
        <Text className="text-lg font-semibold mb-1 text-foreground">
          {user.name || 'Unknown User'}
        </Text>
        {displayUsername && (
          <Text className="text-sm text-muted-foreground">
            {displayUsername}
          </Text>
        )}
        {user.bio && (
          <Text className="text-sm mt-1 text-muted-foreground" numberOfLines={2}>
            {user.bio}
          </Text>
        )}
      </View>
    </Pressable>
  );
}
